import React from "react";
import { connect as connectFormik } from 'formik';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { withLocalize, Translate } from 'react-localize-redux';
import BbDatePicker from "../common/datePicker";
import BbInput from '../styling/bbInput';
import MarketingSection from '../marketingList/marketingSection';
import moment from 'moment';
import AddressPremises from "../marketingList/sections/addressPremises";

const COUNT_MIN = 0;
const COUNT_MAX = 999999;
const SUM_MIN = 0;
const SUM_MAX = 999999999999;

class ExtendedSearchComponent extends React.Component {

    render() {
        if (this.props.type === "params") {
            return (<MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} section="extended" field={this.props.field} searchTip={isNullOrUndefined(this.props.searchTip) ? null : this.props.translate(this.props.searchTip)
            } errors={this.props.errors} >
                {this.props.field !== "premises" ? this.renderYesNo() : this.renderThreeStateRadioInput()}
                {this.props.field !== "premises" ? <>
                    {this.props.field === "procurements" && this.renderDirection()}
                    {this.renderDate()}
                    {this.renderCount()}
                    {this.renderSum()}
                    {this.renderCurrency()}
                </> : <>{this.renderAddress()}</>
                }
            </MarketingSection>);
        }

        return (
            <>
                {this.props.field === "procurements" && this.renderDirection()}
                {this.renderDate()}
                {this.renderCount()}
                {this.renderSum()}
            </>
        );
    }

    renderThreeStateRadioInput = () => {
        return (
            <BbInput type='radio' label={this.props.translate(this.props.label)} placeholder={{ type: 'column' }}
                options={[
                    { value: "1", label: 'Premises.SearchType.Actual' },
                    { value: "2", label: 'Premises.SearchType.All' },
                    { value: "3", label: 'Common.No.Lower' }
                ]} idFormat={(val) => `$radio-${this.props.field}-searchType-${val}`}
                checkedValue={this.getValue(this.props.formik.values[this.props.field].searchType.toString(), "1")}
                callback={(val) => this.props.formik.setFieldValue(`${this.props.field}.searchType`, parseInt(val))}
            />
        );
    }

    renderYesNo = () => {
        return (
            <BbInput type='radio' label={this.props.translate(this.props.label)} placeholder={{ type: 'column' }}
                options={[
                    { value: "1", label: 'Common.Yes.Lower' },
                    { value: "0", label: 'Common.No.Lower' }
                ]} idFormat={(val) => `$radio-${this.props.field}-hasItems-${val}`}
                checkedValue={this.getValue(this.props.formik.values[this.props.field].hasItems, "1")}
                callback={(val) => this.props.formik.setFieldValue(`${this.props.field}.hasItems`, val)}
            />
        );
    }

    renderDirection = () => {
        return (
            <BbInput type='radio' label={this.props.translate('MarketingList.Procurements.Direction')} placeholder={{ type: 'column' }}
                options={[
                    { value: "0", label: 'Common.DoesNotMatter' },
                    { value: "1", label: 'MarketingList.Procurements.Direction.Submitter' },
                    { value: "2", label: 'MarketingList.Procurements.Direction.Supplier' }
                ]} idFormat={(val) => `$radio-${this.props.field}-direction-${val}`}
                checkedValue={this.getValue(this.props.formik.values[this.props.field].direction, "0")}
                callback={(val) => this.props.formik.setFieldValue(`${this.props.field}.direction`, val)}
            />
        );
    }

    renderAddress = () => {
        return <MarketingSection name={this.props.translate("MarketingList.Premises.Addr")} isOpen={true} section="extended" field={this.props.field}>
                <AddressPremises />
                </MarketingSection>
    }

    renderDate = () => {
        return (
            <div className='field bb-field'>
                <div className="columns">
                    <div className="column is-4 bb-input-label-column">
                        <div className="label-wrapper">
                            <span className="marketing-label"><Translate id="Report.Common.Date" /></span>
                        </div>
                    </div>
                    <div className="is-flex w-100">
                        <div className="column is-6">
                            <BbDatePicker enableReinitialize
                                afterDateChange={d => this.onDateChange(`${this.props.field}.from`, d)}
                                field={`${this.props.field}.from`}
                                value={this.props.formik.values[this.props.field].from}
                                formDateFormat={"DD.MM.YYYY"}
                                placeholder={this.props.translate("Report.Common.From")}
                                yearsBack={120}
                                showError
                            />
                        </div>
                        <div className="column is-6">
                            <BbDatePicker enableReinitialize
                                afterDateChange={d => this.onDateChange(`${this.props.field}.to`, d)}
                                field={`${this.props.field}.to`}
                                value={this.props.formik.values[this.props.field].to}
                                formDateFormat={"DD.MM.YYYY"}
                                placeholder={this.props.translate("Report.Common.To")}
                                yearsBack={120}
                                showError
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onDateChange = (field, day) => {
        if (moment(day, "l", true).isValid())
            this.props.formik.setFieldValue(field, moment(day, "l").format("DD.MM.YYYY"));
        else if (moment(day, "L", true).isValid())
            this.props.formik.setFieldValue(field, moment(day, "L").format("DD.MM.YYYY"));
        else if (day === "")
            this.props.formik.setFieldValue(field, "");
    }

    renderCount = () => {
        return (
            <div className='field bb-field'>
                <div className="columns">
                    <div className="column is-4 bb-input-label-column">
                        <div className="label-wrapper">
                            <span className="marketing-label"><Translate id="Search.Common.Count" /></span>
                        </div>
                    </div>
                    <div className="is-flex w-100">
                        <div className="column is-6 bb-input-column">
                            <BbInput
                                label={this.props.translate("Report.Common.From")}
                                name={`${this.props.field}.countFrom`}
                                type="number"
                                min={COUNT_MIN}
                                max={COUNT_MAX}
                                placeholder={{ type: 'inline' }}
                                style={{ paddingLeft: "0", paddingRight: "0" }}
                            />
                        </div>
                        <div className="column is-6 bb-input-column">
                            <BbInput
                                label={this.props.translate("Report.Common.To")}
                                name={`${this.props.field}.countTo`}
                                type="number"
                                min={COUNT_MIN}
                                max={COUNT_MAX}
                                placeholder={{ type: 'inline' }}
                                style={{ paddingLeft: "0", paddingRight: "0" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSum = () => {
        return (
            <div className='field bb-field'>
                <div className="columns">
                    <div className="column is-4 bb-input-label-column">
                        <div className="label-wrapper">
                            <span className="marketing-label"> <Translate id="Search.Common.Sum" /></span>
                        </div>
                    </div>
                    <div className="is-flex w-100">
                        <div className="column is-6 bb-input-column">
                            <BbInput
                                label={this.props.translate("Report.Common.From")}
                                name={`${this.props.field}.sumFrom`}
                                type="number"
                                min={SUM_MIN}
                                max={SUM_MAX}
                                placeholder={{ type: 'inline' }}
                                style={{ paddingLeft: "0", paddingRight: "0" }}
                            />
                        </div>
                        <div className="column is-6 bb-input-column">
                            <BbInput
                                label={this.props.translate("Report.Common.To")}
                                name={`${this.props.field}.sumTo`}
                                type="number"
                                min={SUM_MIN}
                                max={SUM_MAX}
                                placeholder={{ type: 'inline' }}
                                style={{ paddingLeft: "0", paddingRight: "0" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCurrency = () => {
        return (
            <BbInput type='radio' label={this.props.translate('Common.Currency')} placeholder={{ type: 'column' }}
                options={this.getCurrencyLabels()}
                idFormat={(val) => `$radio-${this.props.field}-currency-${val}`}
                checkedValue={this.props.formik.values[this.props.field].currency}
                callback={(val) => this.props.formik.setFieldValue(`${this.props.field}.currency`, val)}
            />
        );
    }

    getValue(value, defaultValue) {
        return (isNullOrUndefined(value) || value === "") ? defaultValue : value;
    }

    getCurrencyLabels = () => {
        return [
            { label: "Common.DoesNotMatter", value: "" },
            { label: "CZK", value: "CZK" },
            { label: "EUR", value: "EUR" }
        ];
    }

    onNumberChanged = (fieldName, value, setFieldValue, defaultValue = null, min = null, max = null) => {
        let parsed = parseInt(value);
        if (isNullOrUndefined(parsed) || isNaN(parsed))
            parsed = defaultValue;
        if (!isNullOrUndefined(parsed) && !isNullOrUndefined(min) && !isNaN(min) && parsed < min)
            parsed = min;
        if (!isNullOrUndefined(parsed) && !isNullOrUndefined(max) && !isNaN(max) && parsed > max)
            parsed = max;
        setFieldValue(fieldName, isNullOrUndefined(parsed) ? "" : parsed);
    }
}

export default withLocalize(connectFormik(ExtendedSearchComponent));